/**
 * Custom attributes (AB#14524 / #13810 / #13811).
 *
 * An attribute is "custom" only when an SME explicitly ticks **Mark as custom
 * attribute** on the Create/Edit Attribute screen. The flag is the backend's
 * `is_custom` boolean on the graph Attribute node; every read projects it as
 * `is_custom` and the FE keeps it camelCased as `isCustom` on row types.
 *
 * Both entry points that create attributes — the Attributes module form
 * (`Components/GMS/Attribute/AddEditViewAttr.jsx`) and the shared
 * `CreateAttributeModal` used by Data Review and Data Mapping — import the copy
 * from here so the checkbox reads identically everywhere (AC 3 of #14524).
 */
export const CUSTOM_ATTRIBUTE_CHECKBOX_LABEL = 'Mark as custom attribute';

export const CUSTOM_ATTRIBUTE_TOOLTIP =
  'Marking this attribute as custom will tag it, display it in the Data Review module, and protect it from being overridden by connector runs.';

/** Tooltip on the tag icon shown before a custom attribute's name in Data Review (#13810 AC 5). */
export const CUSTOM_ATTRIBUTE_TAG_TOOLTIP = 'Custom attribute';
